import { Link, useLocation } from "react-router-dom";

/**
 * Center primary navigation for desktop. Highlights the active route with an
 * ember underline. Studio/Admin items are conditionally added by the caller.
 */
export default function DesktopNav({ items }) {
  const loc = useLocation();
  const isActive = (to) => (to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to));

  return (
    <nav className="hidden md:flex items-center gap-1 font-mono text-xs uppercase tracking-[0.2em]">
      {items.map((n) => {
        const active = isActive(n.to);
        return (
          <Link
            key={n.key}
            to={n.to}
            data-testid={`nav-${n.key}`}
            className={`relative px-4 py-2 transition-colors ${
              active
                ? n.emphasize ? "text-[#FF4500] font-bold" : "text-[#FF4500]"
                : n.emphasize ? "text-[#FF4500]/80 hover:text-[#FF4500]" : "text-gray-300 hover:text-white"
            }`}
          >
            {n.label}
            {active && <span className="absolute left-4 right-4 -bottom-[3px] h-[2px] bg-[#FF4500]" />}
          </Link>
        );
      })}
    </nav>
  );
}
